import $ from "jquery";

const init = () => {
  playAnimation();
};

const playAnimation = () => {
  $(window).on("scroll", () => {
    if (window.scrollY > 1400) {
      $(".animated-line").addClass("animate");
    }
  });
};

try {
  init();
} catch (error) {
  console.log(error);
}
